const baseNumberContent = {
  type: "image",
  inputType: "",
  label: "",
  data: {
    id: "",
    key: "",
    value: "",
    type: "icon",
    file: {},
    isUpdated: false,
  },
  translation: {
    input: "",
    flag: false,
    isUpdated: false,
  },
};

const createNumberEntry = (title: string, key: string) => ({
  title,
  content: {
    ...baseNumberContent,
    data: {
      ...baseNumberContent.data,
      key,
      value: "",
    },
    translation: {
      ...baseNumberContent.translation,
    },
  },
  isRequired: false,
  readonly: false,
  isButton: true,
});

const numberEntries = [
  { title: "0", key: "num0" },
  { title: "1", key: "num1" },
  { title: "2", key: "num2" },
  { title: "3", key: "num3" },
  { title: "4", key: "num4" },
  { title: "5", key: "num5" },
  { title: "6", key: "num6" },
  { title: "7", key: "num7" },
  { title: "8", key: "num8" },
  { title: "9", key: "num9" },
  { title: "Comma", key: "comma" },
];

const numbers = numberEntries.map(({ title, key }) =>
  createNumberEntry(title, key)
);

export { numbers };
